module.exports = __webpack_public_path__ + "img/logo.56b25085.png";